import React, { Component } from 'react';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Page from '../Common/Page/page';
import DashboardsDemoDataViewContainer from '../../../containers/Administration/PsManagementPage/dashboardsDemoDataViewContainer.js';
import {PsManagementMenuItemsIds} from '../../../enums/navigationMenuItemsIds';
import PageNotFoundPageContainer from '../../../containers/PageNotFoundPage/pageNotFoundPageContainer.js';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import {getRoutesFor, getSideNavigatorMenuItems} from '../../../utils/routerHelper';
import WorkOrdersManagementView from './WorkOrdersManagementView/workOrdersManagementView';
import AssetsManagementView from './AssetsManagementView/assetsManagementView';

require('./psManagementPage.scss');

export default class PsManagement extends Component {

  constructor (props) {
    super(props);
    this.labels = createLabelHelper('mat.administration.psmanagement.sidenavigator.');
    this.isAuthorizedUser = PermissionManager.hasPSManagementTabPermissions();
    this.navigationItems = this.getNavigationItems();
  }

  componentDidMount() {
    this.props.actions.init(true);

  }

  getNavigationItems() {
    let items = [];
    if(this.isAuthorizedUser) {
      items = [
        {
          id: PsManagementMenuItemsIds.NAV_ELEMENT_DASHBOARDS_DEMO_DATA,
          label: this.labels.get('menuitem.dashboardsDemoData'),
          link: '/Administration/psManagement/dashboardsDemoData',
          component: DashboardsDemoDataViewContainer,
          isAllowed: true
        },
        {
          id: PsManagementMenuItemsIds.NAV_ELEMENT_WORK_ORDERS_MANAGEMENT,
          label: this.labels.get('menuitem.workOrdersManagement'),
          link: '/Administration/psManagement/workOrdersManagement',
          component: WorkOrdersManagementView,
          isAllowed: true
        },
        {
          id: PsManagementMenuItemsIds.NAV_ELEMENT_ASSETS_MANAGEMENT,
          label: this.labels.get('menuitem.assetsManagement'),
          link: '/Administration/psManagement/assetsManagement',
          component: AssetsManagementView,
          isAllowed: true
        },
      ];
    }
    return items;
  }

  getDefaultRouteConfig() {
    return {
      key: `${this.navigationItems?.[0]?.id}_default`,
      path: '/Administration/psManagement',
      redirectPath: this.navigationItems?.[0]?.items?.[0]?.link || this.navigationItems?.[0]?.link,
      routeNotFoundComponent: PageNotFoundPageContainer
    }
  }

  render() {
    return (<Page className="mat-settings-page"
                  selectedMenuItemId={this.props.sData.get('selectedMenuItemId')}
                  sideNavigatorMenuItems={getSideNavigatorMenuItems(this.navigationItems)}
                  actions={this.props.actions}
                  routes={getRoutesFor(this.navigationItems, this.getDefaultRouteConfig())}/>);

  }

};







